<div style="width: 100%; height: 100%">

    <div  id="add_notifcation-modal" *ngIf="modalTitle == 'Scan For New Beacons'">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Scan For New Beacons</mat-label>
            </div>  
            <br>     
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="scanNewBeacons()" >Scan</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_notifcation-modal" *ngIf="modalTitle == 'Link To Work Order'" [formGroup]="linkToLadingForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Link to Work Order</mat-label>
            </div>  
            <br>     
            <mat-form-field style="width: 100%;">
                <mat-label>Work Order Number</mat-label>
                <input matInput formControlName="alternate_reference">
                <input matInput type="string" formControlName="beacon_device_uuid" hidden >   
            </mat-form-field>    
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="linkToLading()" >Link</button>
                <button type="button" class="confirm"  (click)="resetLink()" >Reset</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>

    <div  id="add_notifcation-modal" *ngIf="modalTitle == 'Set Return Courier'" [formGroup]="setCourierForm">
        <div class="delete-modal-inner">
            <div class="delete-modal-content">
                <mat-label style = "font-size: 16px;">Set Return Courier</mat-label>
            </div>  
            <br>     
            <mat-form-field style="width: 100%;">
                <mat-label>Courier Name</mat-label>
                <input matInput formControlName="return_courier">
                <input matInput type="string" formControlName="beacon_device_uuid" hidden >   
            </mat-form-field>    
            <mat-form-field style="width: 100%;">
                <mat-label>Tracking Number</mat-label>
                <input matInput formControlName="tracking_number">
            </mat-form-field>                
            <div class="delete-modal-buttons">
                <button type="button" class="confirm"  (click)="setCourier()" >Set</button>
                <button type="button" class="confirm"  (click)="resetReturnCourier()" >Reset</button>
                <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>